export enum Role {
  client = 'client',
  subclient = 'sub-client',
  salesman = 'salesman',
  subclientEnchanced = 'sub-client-enchanced',
  none = '',
}
